import React, {Component} from 'react';
import PropTypes from 'prop-types';

class SiteOverview extends Component {
  constructor(props) {
    super(props);
  }

  getSiteHealthComponent() {
    if (this.props.data.health.health === 'Healthy') {
      return (
        <span className='analytics-ok'><img src="/assets/images/management/up.png" alt="Up" /></span>
      );
    } else if (this.props.data.health.health === 'Degraded') {
      return [
        <span key="1" className='analytics-warning'><img src="/assets/images/management/degraded.png" alt="Degraded" /></span>,
        <span key="2" className='analytics-warning'>Degraded</span>,
      ];
    } else if (this.props.data.health.health === 'Severe') {
      return [
        <span key="1" className='analytics-fail'><img src="/assets/images/management/down.png" alt="Down" /></span>,
        <span key="2" className='analytics-fail'>Severe</span>,
      ];
    }

    return '';
  }

  getTerminalsOfflineText() {
    return this.props.data.health.offlineTerminals.length + ' ' +
      (this.props.data.health.offlineTerminals.length === 1 ? 'terminal' : 'terminals') + ' offline';
  }

  getTerminalsBatteryText() {
    return this.props.data.health.emptyTerminals.length + ' terminal ' +
      (this.props.data.health.emptyTerminals.length === 1 ? 'battery' : 'batteries') + ' low';
  }

  getUnsyncedTerminalsText() {
    return this.props.data.health.unsyncedTerminals.length + ' terminal ' +
      (this.props.data.health.unsyncedTerminals.length === 1 ? 'clock' : 'clocks') + ' unsynced';
  }

  getOfflineGatewaysText() {
    return this.props.data.health.offlineGateways.length + ' ' +
      (this.props.data.health.offlineGateways.length === 1 ? 'gateway' : 'gateways') + ' offline';
  }

  getOfflineRoutersText() {
    return this.props.data.health.offlineRouters.length + ' ' +
      (this.props.data.health.offlineRouters.length === 1 ? 'repeater' : 'repeaters') + ' offline';
  }

  getControllerIP() {
    return this.props.data.gateways.filter((gateway) => gateway.controller)[0].ip;
  }

  getTerminalCountOfGatewayRouter(gateway) {
    const terminals = this.props.data.terminals ?? [];

    if (terminals.filter((t) => t.routerId !== undefined).length > 0) {
      return terminals.filter((t) => t.routerId === 'gw' && t.gatewayId === gateway.id).length;
    }

    return null;
  }

  getTerminalCountOfGateway(gateway) {
    const terminals = this.props.data.terminals ?? [];
    return terminals.filter((t) => t.gatewayId === gateway.id).length;
  }

  getGatewayOperationText(gateway) {
    if (!gateway.operation) {
      return '';
    }

    if (gateway.operation === 'adding_routers') {
      return 'Power-on repeaters to add!';
    }

    return gateway.operation ? gateway.operation.replaceAll('_', ' ') + '...' : '';
  }

  getRouterName(routerId) {
    const gateways = this.props.data.gateways ?? [];
    return routerId === 'gw' ?
      'Gateway' :
      gateways.flatMap((g) => g.routers).filter((r) => r.id === routerId).map((g) => g.name[0].text)[0];
  }

  getTerminalCountOfRouter(router) {
    const terminals = this.props.data.terminals ?? [];

    if (terminals.filter((t) => t.routerId !== undefined).length > 0) {
      return terminals.filter((t) => t.routerId === router.id).length;
    }

    return '';
  }

  getGatewayName(gatewayId) {
    return (this.props.data.gateways ?? []).filter((g) => g.id === gatewayId).map((g) => g.name[0].text)[0];
  }

  formatTimeDeviation(timeDeviation) {
    if (timeDeviation === 0) {
      return 'Synced';
    }
    if (Math.abs(timeDeviation) > 3 * 3600000) {
      return 'Not set';
    }

    const str = Math.abs(timeDeviation) < 120000 ?
      Math.round(timeDeviation / 1000) + 'sec' :
      Math.abs(timeDeviation) < 7200000 ?
        Math.round(timeDeviation / 60000) + 'min' :
        Math.round(timeDeviation / 3600000) + 'h';
    return timeDeviation < 0 ? '' + str : '+' + str;
  }

  isFirmwareUpToDate(firmwareVersion) {
    return firmwareVersion >= this.getFirmwareVersion(this.props.minimumFirmwareVersionString);
  }

  getFirmwareVersion(versionString) {
    const strings = versionString.split('.');
    let value = 0;
    strings.forEach((s) => {
      value *= 256;
      value += +s;
    });
    return value;
  }

  getTerminalOperationText(terminal) {
    if (terminal.operation === 'adding') {
      if (terminal.online) {
        return '';
      } else {
        return 'Present WKC to terminal!';
      }
    } else {
      return terminal.operation ? terminal.operation.replaceAll('_', ' ') + '...' : '';
    }
  }

  getRepeaterRow(gateway) {
    if (!gateway.routers) {
      return '';
    }

    return (
      gateway.routers.map((router) => {
        return (
          <tr key={gateway.id} className="analytics-row">
            <td>
              <img src="/assets/images/management/router.png" alt="Router"/>
            </td>

            <td className='analytics-router-column'>
              <span className="analytics-device" onClick={() => { }}>{router.name[0].text}</span>
              <span className="analytics-info">Repeater {router.id}</span>
            </td>

            <td>
              {router.online === undefined ?
                (this.props.data.refreshInProgress ?
                  <span className='analytics-info'>
                    <progress></progress>
                  </span> : ''
                ) :
                (!router.online ?
                  <div>
                    <span key="1" className="analytics-fail">
                      <img src="/assets/images/management/down.png" alt="Down"/>
                    </span>
                    <span key="2" className="analytics-fail">Offline</span>
                  </div> :
                  <span className='analytics-ok'>
                    <img src="/assets/images/management/up.png" alt="Up"/>
                  </span>
                )
              }

              {router.routerId !== undefined && this.getRouterName(router.routerId) !== undefined ?
                <span className="analytics-info">
                  <img src="/assets/images/management/router-green.png" alt="Router"/>
                  {this.getRouterName(router.routerId)}
                </span> : ''
              }

              {router.pathCost !== undefined ? router.pathCost <= this.props.maximumPathCost ?
                  <span className='analytics-info'>
                    <img src="/assets/images/management/path-green.png" alt="Path"/>
                    {router.pathCost}
                  </span> :
                  <span className='analytics-fail'>
                    <img src="/assets/images/management/path-red.png" alt="Path"/>
                    {router.pathCost}
                  </span> : ''
              }

              {router.online === true && this.getTerminalCountOfRouter(router) !== undefined ?
                <span className='analytics-info'>
                  <img src="/assets/images/management/terminal-green.png" alt="Terminal"/>
                  {this.getTerminalCountOfRouter(router)}/{this.getTerminalCountOfGateway(gateway)}
                </span> : ''
              }

            </td>

            <td>
              {/* Leave empty */}
            </td>
          </tr>
        );
      })
    );
  }

  render() {
    return (
      <div className="app-body">
        <table>
          <tbody>
            {/* Header row */}
            <tr className="analytics-row">
              <td>
                <img src="/assets/images/management/site.png" alt="Site" />
              </td>
              <td>
                <span className="analytics-device">{this.props.data.health.siteName ? this.props.data.health.siteName[0].text : ''}</span>
              </td>
              <td>
                {this.getSiteHealthComponent()}

                {this.props.data.health.secure === true ?
                  <span className="analytics-fail">
                    <img src="/assets/images/management/safe-green.png" alt="Secure" title="Secure"/>
                  </span> : ''
                }

                {
                  this.props.data.health.terminalsCount !== undefined ?
                  this.props.data.health.maxTerminalsCount !== null ?
                    <span className="analytics-info">
                      <img src="/assets/images/management/terminal-green.png" alt="Terminal"/>
                      {this.props.data.health.terminalsCount}/{this.props.data.health.maxTerminalsCount} terminals commissioned
                    </span> :
                    <span className="analytics-info">
                      <img src='/assets/images/management/terminal-green.png' alt="Terminal"/>
                      {this.props.data.health.terminalsCount} terminals commissioned
                    </span> : ''
                }

                {
                  this.props.data.health.offlineTerminals.length > 0 ?
                    <span className="analytics-info">
                      <img src="/assets/images/management/terminal-green.png" alt="Terminal"/>
                      {this.getTerminalsOfflineText()}
                    </span> : ''
                }

                {
                  this.props.data.health.emptyTerminals.length > 0 ?
                      <span className="analytics-info"><img src="/assets/images/management/battery-green.png" alt="Terminal"/>
                        {this.getTerminalsBatteryText()}
                      </span> : ''
                }

                {
                  this.props.data.health.unsyncedTerminals.length > 0 ?
                      <span className="analytics-info">
                        <img src="/assets/images/management/clock-green.png" alt="Clock"/>
                        {this.getUnsyncedTerminalsText()}
                      </span> : ''
                }

                {
                  this.props.data.health.hmsOffline === true ?
                  <span className="analytics-info">
                    <img src="/assets/images/management/hms-green.png" alt="HMS"/>
                    HMS offline
                  </span> : ''
                }

                {
                  this.props.data.health.offlineGateways.length > 0 ?
                    <span className="analytics-info"><img src="/assets/images/management/gateway-green.png" alt="Gateway"/>
                      {this.getOfflineGatewaysText()}
                    </span> : ''
                }

                {
                  this.props.data.health.offlineRouters.length > 0 ?
                    <span className="analytics-info">
                      <img src="/assets/images/management/router-green.png" alt="Router"/>
                      {this.getOfflineRoutersText()}
                    </span> : ''
                }
              </td>
            </tr>

            {/* HMS/Site Agent row */}
            {
              this.props.data.hms !== undefined ?
                <tr className='analytics-row'>
                  <td>
                    <img src="/assets/images/management/hms.png" alt="HMS"/>
                  </td>
                  <td>
                    <span className="analytics-device">Dialock</span>
                    <span className="analytics-info"></span>
                  </td>
                  <td>
                    {
                      this.props.data.hms.webServiceOnline === false ?
                        (this.props.data.refreshInProgress ?
                          <span className='analytics-info'>
                            <progress></progress>
                          </span> : ''
                        ) :
                        (this.props.data.hms.online === true ?
                          <span className='analytics-ok'>
                            <img src="/assets/images/management/up.png" alt="Up"/>
                          </span> :
                          [
                            <span key="key1" className='analytics-fail'>
                              <img src="/assets/images/management/down.png" alt="Down"/>
                            </span>,
                            <span key="key2" className='analytics-fail'>Offline</span>,
                          ]
                        )
                    }
                  </td>
                </tr> : ''
            }

            {this.props.data.gateways ?
              this.props.data.gateways.map((gateway) => {
                return [
                  <tr key={gateway.id} className="analytics-row">
                    <td>
                      <img src="/assets/images/management/gateway.png" alt="Gateway"/>
                    </td>
                    <td>
                      <span className="analytics-device" onClick={() => { }}>{gateway.name[0].text}</span>
                      <span className="analytics-info">Gateway {gateway.mac}</span>
                    </td>

                    <td>
                      {gateway.online === false ?
                        this.props.data.refreshInProgress ?
                          <span className='analytics-info'>
                            <progress></progress>
                          </span> :
                          [
                            <span key="key1" className='analytics-fail'>
                              <img src="/assets/images/management/down.png" alt="Down"/>
                            </span>,
                            <span key="key2" className='analytics-fail'>Offline</span>,
                          ] :
                        <span className='Analytics-ok'>
                          <img src="/assets/images/management/up.png" alt="Up"/>
                        </span>
                      }

                      {
                        gateway.controllerIp !== null && this.props.data.gateways.length > 0 ?
                          gateway.controllerIp === this.getControllerIP() ?
                            (gateway.controller === false ?
                              <span className='analytics-info'>
                                <img src="/assets/images/management/gateway-green.png" alt="Gateway"/>
                                &nbsp;
                                {this.props.data.gateways[0].name[0].text}
                              </span> : '') :
                            <span className='analytics-fail'>
                              <img src="/assets/images/management/gateway-green.png" alt="Gateway"/>
                              &nbsp;
                              {this.props.data.gateways[0].name[0].text} @ {gateway.controllerIp}
                            </span> : ''
                      }

                      {gateway.ip !== undefined ?
                        <span className='analytics-info'>IP {gateway.ip}</span> : ''
                      }

                      {gateway.firmwareVersionString !== null ?
                        <span className='analytics-info'>Firmware {gateway.firmwareVersionString}</span> : ''
                      }

                      {gateway.configurationVersionString !== null ?
                        <span className='analytics-info'>Configuration {gateway.configurationVersionString}</span> : ''
                      }

                      {gateway.online === true ? this.getTerminalCountOfGatewayRouter(gateway) === null ?
                          <span className='analytics-info'>
                            <img src="/assets/images/management/terminal-green.png" alt="Terminal"/>
                            {this.getTerminalCountOfGateway(gateway)}
                          </span> :
                          <span className='analytics-info'>
                            <img src="/assets/images/management/terminal-green.png" alt="Terminal"/>
                            {this.getTerminalCountOfGatewayRouter(gateway)}/{this.getTerminalCountOfGateway(gateway)}
                          </span> : ''
                      }

                      {gateway.operation !== null ?
                        <span className='analytics-operation'>
                          {this.getGatewayOperationText(gateway)}
                        </span> :
                        gateway.firmwareUpdateInProgress ?
                          <span className='analytics-operation'>
                            Updating firmware <progress></progress>
                          </span> : ''
                      }
                    </td>
                  </tr>,
                  this.getRepeaterRow(gateway),
                ];
              }) : ''
            }

            {this.props.data.terminals ?
              this.props.data.terminals.map((terminal) => {
                return (
                  <tr key={terminal.terminalId} className='analytics-row'>
                    <td>
                      <img src="/assets/images/management/terminal.png" alt="Terminal" />
                    </td>
                    <td>
                      <span className="analytics-device" onClick={() => {}}>
                        {terminal.name[0].text + (terminal.public ? ' (!)' : '')}
                      </span>
                      <span className="analytics-info">{terminal.type}</span>
                    </td>

                    <td>
                      {terminal.added === false ?
                        (this.props.data.refreshInProgress ?
                          <span className='analytics-info'>
                            <progress></progress>
                          </span> : ''
                        ) :
                        !terminal.added || (terminal.operation === 'adding' && !terminal.online) ?
                          '' :
                          !terminal.online ?
                            [
                              <span key="key1" className='analytics-fail'>
                                <img src="/assets/images/management/down.png" alt="Down"/>
                              </span>,
                              <span key="key2" className='analytics-fail'>Offline</span>,
                            ]:
                            <span className='analytics-ok'>
                              <img src="/assets/images/management/up.png" alt="Up"/>
                            </span>
                      }

                      {terminal.gatewayId !== null ?
                        <span className="analytics-info">
                          <img src="/assets/images/management/gateway-green.png" alt="Gateway"/>
                          &nbsp;
                          {this.getGatewayName(terminal.gatewayId)}
                        </span> : ''
                      }

                      {terminal.routerId !== null && this.getRouterName(terminal.routerId) !== undefined ?
                        <span className="analytics-info">
                          <img src="/assets/images/management/router-green.png" alt="Router"/>
                          &nbsp;
                          {this.getRouterName(terminal.routerId)}
                        </span> : ''
                      }

                      {terminal.pathCost !== null && terminal.linkCost !== null ?
                        terminal.pathCost <= this.props.maximumPathCost ?
                          <span className='analytics-info'>
                            <img src="/assets/images/management/path-green.png" alt="Path"/>
                            &nbsp;
                            {terminal.pathCost - terminal.linkCost}+{terminal.linkCost}
                          </span> :
                          <span className='analytics-fail'>
                            <img src="/assets/images/management/path-red.png" alt="Path"/>
                            &nbsp;
                            {terminal.pathCost - terminal.linkCost}+{terminal.linkCost}
                          </span> : ''
                      }

                      {terminal.batteryPercentage !== null ?
                        (terminal.batteryPercentage >= this.props.minimumBatteryPercentage ?
                            <span className='analytics-info'>
                              <img src="/assets/images/management/battery-green.png" alt="Battery"/>
                              &nbsp;
                              {terminal.batteryPercentage}%
                            </span> :
                            <span className='analytics-fail'>
                              <img src="/assets/images/management/battery-red.png" alt="Battery"/>
                              &nbsp;
                              {terminal.batteryPercentage}%
                            </span>
                        ) : ''
                      }

                      {terminal.terminalTimeDeviation !== null ?
                        (Math.abs(terminal.terminalTimeDeviation) <= this.props.maximumTimeDeviation * 1000 ?
                            <span className='analytics-info'>
                              <img src="/assets/images/management/clock-green.png" alt="Clock"/>
                              &nbsp;
                              {this.formatTimeDeviation(terminal.terminalTimeDeviation)}
                            </span> :
                            <span className='analytics-fail'>
                              <img src="/assets/images/management/clock-red.png" alt="Clock"/>
                              &nbsp;
                              {this.formatTimeDeviation(terminal.terminalTimeDeviation)}
                            </span>
                        ) : ''
                      }

                      {terminal.firmwareVersionString !== null && terminal.firmwareVersion !== null ?
                        (this.isFirmwareUpToDate(terminal.firmwareVersion) ?
                            <span className='analytics-info'>
                              Firmware {terminal.firmwareVersionString}
                            </span> :
                            <span className='analytics-fail'>
                              Firmware {terminal.firmwareVersionString}
                            </span>
                        ) : ''
                      }

                      {terminal.totalLockCycleCount !== null ?
                        <span className='analytics-info'>{Math.round(terminal.totalLockCycleCount / 2)} unlocks</span> : ''
                      }

                      {terminal.operation !== null && this.getTerminalOperationText(terminal) !== '' ?
                        <span className='analytics-operation'>
                          {this.getTerminalOperationText(terminal)}
                          <progress></progress>
                        </span> : ''
                      }
                    </td>
                  </tr>
                );
              }) : ''
            }
          </tbody>
        </table>
      </div>
    );
  }
}

SiteOverview.propTypes = {
  siteId: PropTypes.number,
  error: PropTypes.string,
  data: PropTypes.object,
  minimumFirmwareVersionString: PropTypes.string,
  maximumPathCost: PropTypes.string,
  maximumTimeDeviation: PropTypes.string,
  minimumBatteryPercentage: PropTypes.string,
};

export default SiteOverview;
